const status = {
  modifiedBooking: 'bookings_status_modified_booking',
  canceledBooking: 'bookings_status_canceled_booking',
  bookingIssued: 'bookings_status_booking_issued',
  ticketIssued: 'bookings_status_ticket_issued',
  ticketVoid: 'bookings_status_ticket_void',
  modifiedTicket: 'bookings_status_modified_ticket',
  revalidatedTicket: 'bookings_status_revalidated_ticket',
  repricedTicket: 'bookings_status_repriced_ticket',
  canceledTicket: 'bookings_status_canceled_ticket',
}

const detailed = {
  flight: 'bookings_detailed_ticket',
  hotel: 'bookings_detailed_booking',
  insurance: 'bookings_detailed_insurance',
}

const actions = {
  modifyBooking: 'dashboard_modify-booking',
  cancelBooking: 'bookings_action_cancel_booking',
  issueTicket: 'bookings_action_issue_ticket',
  revalidateTicket: 'bookings_action_revalidate_ticket',
  cancelTicket: 'bookings_action_cancel_ticket',
  repriceTicket: 'bookings_action_reprice_ticket',
}

const type = {
  flight: 'flight',
  hotel: 'hotel',
  insurance: 'insurance',
}

const timeline = {
  booked: 'status_BOOKED',
  finished: 'status_FINISHED',
}

const colsToShowInit = [
  'type',
  'passengerName',
  'provider',
  'reservationStatus',
  'pnrLocator',
  'bookedOn',
  'bookedForDate'
]
const sortInit = {
  sortType: 'desc',
  sortByField: 'bookedOn',
}

const colsShowName = [
  { label:'dashboard_type', value:'type', order:1 },
  { label:'dashboard_passenger', value:'passengerName', order:4 },
  { label:'dashboard_provider', value:'provider', order:5 },
  { label:'dashboard_state', value:'reservationStatus', order:3 },
  { label:'bookings_pnrLocator', value:'pnrLocator', order:6 },
  { label:'bookings_bookedOn', value:'bookedOn', order:2 },
  { label:'dashboard_booking', value:'bookedForDate', order:7 },
  { label:'dashboard_provider-reference', value:'providerRef', order:8 },
  { label:'dashboard_deadline-to-issue', value:'issueDateLimit', order:9 },
  { label:'dashboard_insurance', value:'insurance', order:10 },
  { label:'dashboard_gross-amount', value:'price', order:11 },
]

const numbersPage = [
  { value: 10, label: '10' },
  { value: 20, label: '20' },
  { value: 50, label: '50' },
  { value: 100, label: '100' },
]

const filterType = [
  { value: 'all', label: 'all' },
  { value: 'flight', label: 'flight' },
  { value: 'hotel', label: 'hotel' }
]

export default {
  status,
  type,
  actions,
  detailed,
  timeline,
  colsToShowInit,
  sortInit,
  colsShowName,
  numbersPage,
  filterType
}
